import React from 'react';
// import React, { lazy, Suspense } from 'react';
// import CircularProgress from '@material-ui/core/CircularProgress';
import Contract from '../../assets/icons/Contract.png';
import {
  Person,
  School,
  HomeWork,
  Group,
  AttachFile,
  AssignmentTurnedIn,
  Payment,
  Home,
  CloudDone,
} from '@material-ui/icons';

const MaterialIcon = ({ icon, className, fallBackIcon }) => {
  // const Icon = lazy(() => import(`@material-ui/icons/${icon}`));
  switch (icon) {
    case 'Person':
      return <Person className={className}></Person>;

    case 'School':
      return <School className={className}></School>;

    case 'HomeWork':
      return <HomeWork className={className}></HomeWork>;

    case 'Home':
      return <Home className={className}></Home>;

    case 'Homework':
      return <HomeWork className={className}></HomeWork>;

    case 'Group':
      return <Group className={className}></Group>;

    case 'AttachFile':
      return <AttachFile className={className}></AttachFile>;

    case 'AssignmentTurnedIn':
      return <AssignmentTurnedIn className={className}></AssignmentTurnedIn>;

    case 'Payment':
      return <Payment className={className}></Payment>;

    case 'Contract':
      return <img src={Contract} className={className}></img>;

    case 'CloudDone':
      return <CloudDone className={className}></CloudDone>;

    default:
      return <span className={className}>{fallBackIcon}</span>;
  }

  // return (
  //   <Suspense
  //     fallback={
  //       <span style={{ textAlign: 'center', position: 'relative', top: '2px' }}>
  //         {/* <CircularProgress size={20} /> */}
  //         <span
  //           className={className}
  //           style={{ fontSize: '16px', fontWeight: 'bold' }}
  //         >
  //           {' '}
  //           {fallBackIcon}
  //         </span>
  //       </span>
  //     }
  //   >
  //     <Icon className={className} />
  //   </Suspense>
  // );
};

export default MaterialIcon;
